// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a04394{margin-top:.3em !important}._3d9906>div{padding-top:.5em}._78b7f7:before{content:\"/\";margin:0 .5em;font-size:.75em}", ""]);
// Exports
exports.locals = {
	"icons": "a04394",
	"container": "_3d9906",
	"subtitle": "_78b7f7"
};
module.exports = exports;
